// extracted by mini-css-extract-plugin
export default {"appContainer":"HdBtS9VZ"};